module.exports = __webpack_public_path__ + "img/panelView_strong_3_3.246d4335.png";